import React from "react";
import { LANGS, useI18n } from "../i18n";
import { cn } from "../lib/utils";

export const LanguageSwitcher = ({ className }) => {
  const { lang, setLang } = useI18n();
  return (
    <div
      role="group"
      aria-label="Language switcher"
      data-testid="language-switcher"
      className={cn(
        "inline-flex items-center rounded-full border border-border bg-card p-0.5",
        className
      )}
    >
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          data-testid={`language-option-${l.code}`}
          onClick={() => setLang(l.code)}
          aria-pressed={lang === l.code}
          className={cn(
            "px-2.5 py-1 text-xs font-semibold rounded-full transition-colors duration-150",
            lang === l.code
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};
